module.exports = __webpack_public_path__ + "static/media/tv.a595f49d.svg";